import type * as Types from 'app/types/graphql';

import {
  SubscriptionEdgeSelectFragmentDoc,
  SubscriptionSelectFragmentDoc,
} from '../fragments/subscription.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type SubscriptionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.SubscriptionWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.SubscriptionOrder>>;
}>;

export type SubscriptionsQueryResponse = {
  subscriptions?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<{
        node?: Types.Maybe<
          Pick<
            Types.Subscription,
            'id' | 'amount' | 'cappedAmount' | 'planID' | 'shopPlatformID' | 'unit'
          >
        >;
      }>
    >;
  }>;
};

export const SubscriptionsDocument = `
    query Subscriptions($first: Int, $where: SubscriptionWhereInput, $orderBy: [SubscriptionOrder!]) {
  subscriptions(first: $first, where: $where, orderBy: $orderBy) {
    ...SubscriptionEdgeSelect
  }
}
    ${SubscriptionEdgeSelectFragmentDoc}
${SubscriptionSelectFragmentDoc}`;

export const useSubscriptionsQuery = <TData = SubscriptionsQueryResponse, TError = unknown>(
  variables?: SubscriptionsQueryVariables,
  options?: UseQueryOptions<SubscriptionsQueryResponse, TError, TData>,
) => {
  return useQuery<SubscriptionsQueryResponse, TError, TData>(
    variables === undefined ? ['Subscriptions'] : ['Subscriptions', variables],
    appFetcher<SubscriptionsQueryResponse, SubscriptionsQueryVariables>(
      SubscriptionsDocument,
      variables,
    ),
    options,
  );
};

useSubscriptionsQuery.getKey = (variables?: SubscriptionsQueryVariables) =>
  variables === undefined ? ['Subscriptions'] : ['Subscriptions', variables];
